module.exports = __webpack_public_path__ + "static/media/loadingFailedSmall.25fce1f4.jpg";